import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import SignaturePad from 'signature_pad';
const HEIGHT = 180;
let SignatureCanvas = class SignatureCanvas extends Vue {
    pad = null;
    observer = null;
    highlighted = false;
    /** Draws attention to the canvas (e.g. after clicking the signature spot in the preview). */
    highlight() {
        this.$refs.canvas.focus({ preventScroll: true });
        this.highlighted = false;
        this.$nextTick(() => { this.highlighted = true; });
    }
    mounted() {
        this.pad = new SignaturePad(this.$refs.canvas, { backgroundColor: 'rgba(255,255,255,0)' });
        this.pad.addEventListener('endStroke', () => this.$emit('input', this.dataUrl()));
        // Fires on mount, on window resize and when a hidden dialog becomes visible (width 0 -> real width).
        this.observer = new ResizeObserver(this.resize);
        this.observer.observe(this.$refs.canvas);
    }
    beforeDestroy() {
        this.observer?.disconnect();
        this.pad?.off();
    }
    // Canvas bitmap must match its CSS size, otherwise strokes land away from the pointer.
    resize() {
        const canvas = this.$refs.canvas;
        if (canvas.offsetWidth === 0)
            return;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = HEIGHT * ratio;
        canvas.getContext('2d')?.scale(ratio, ratio);
        this.clear();
    }
    dataUrl() {
        return this.pad && !this.pad.isEmpty() ? this.pad.toDataURL('image/png') : null;
    }
    clear() {
        this.pad?.clear();
        this.$emit('input', null);
    }
};
SignatureCanvas = __decorate([
    Component
], SignatureCanvas);
export default SignatureCanvas;
